import { usePresentationContext } from '../../legacy-context/presentationContext';
import { EmbedIntegrationPresentation } from '../../shared/components/embed-integrations/EmbedIntegrationPresentation';
import { buildPowerpointSlidesURL, isValidPowerpointSlidesURL } from './utils';

export function PowerpointPresentation() {
  const { useQuestion } = usePresentationContext();
  const question = useQuestion();

  const { powerpoint_url, starting_slide_number } =
    question.module_custom_data || {
      powerpoint_url: '',
      starting_slide_number: 1,
    };

  return (
    <EmbedIntegrationPresentation
      integrationName="PowerPoint"
      presentationUrl={buildPowerpointSlidesURL(
        powerpoint_url,
        starting_slide_number,
      )}
      isValidUrl={isValidPowerpointSlidesURL}
      focusNoticeEnabled={true}
    />
  );
}
